module.exports = __webpack_public_path__ + "media/dashboard/assets/images/informations_settings-a1b215b1a6faa6a6efaea6391a120471.svg";